import { render, staticRenderFns } from "./BaseOtpInput.vue?vue&type=template&id=619a13a3&scoped=true&"
import script from "./BaseOtpInput.vue?vue&type=script&lang=js&"
export * from "./BaseOtpInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseOtpInput.vue?vue&type=style&index=0&id=619a13a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a13a3",
  null
  
)

export default component.exports